export const LIGHT_ON = 0.35;
export const LIGHT_OFF = 0;

export const ROOM_COLOR = [
  [0x72bca8, 0xe4945e, 0xaeb9cd, 0x6d9cd0, 0xe7e48c, 0xd8ba51, 0xd76b7f],
  [0xddb5b5, 0x95ac7e, 0x5783ca, 0xe88781, 0xa48799, 0xd5cec6, 0xabb962],
  [0xa48799, 0xd76b7f, 0xe7e48c, 0x72bca8, 0xd8ba51, 0xe4945e, 0x6d9cd0],
  [0xd5cec6, 0xe88781, 0xaeb9cd, 0x95ac7e, 0x5783ca, 0xddb5b5, 0xa48799],
];

// const COLOR_GRID = [
//   [0xe88781, 0xaeb9cd, 0xd8ba51, 0xabb962, 0xe4945e, 0x95ac7e, 0x5783ca],
//   [0xd76b7f, 0xe7e48c, 0xd5cec6, 0x72bca8, 0xddb5b5, 0xa48799, 0x6d9cd0],
//   [0xaeb9cd, 0xe7e48c, 0xd76b7f, 0xd8ba51, 0xe88781, 0xabb962, 0x95ac7e],
//   [0x5783ca, 0xddb5b5, 0xa48799, 0x6d9cd0, 0xe4945e, 0x72bca8, 0xd5cec6],
// ];

// const COLOR_GRID2 = [
//   [0x72bca8, 0xe4945e, 0xaeb9cd, 0x6d9cd0, 0xe7e48c, 0xd8ba51, 0xd76b7f],
//   [0xddb5b5, 0x95ac7e, 0x5783ca, 0xe88781, 0xa48799, 0xd5cec6, 0xabb962],
//   [0xa48799, 0xd76b7f, 0xe7e48c, 0x72bca8, 0xd8ba51, 0xe4945e, 0x6d9cd0],
//   [0xd5cec6, 0xe88781, 0xaeb9cd, 0x95ac7e, 0x5783ca, 0xddb5b5, 0xa48799],
// ];

export const ROOM_LIST = [
  101, 102, 103, 104, 105, 106, 107, 201, 202, 203, 204, 205, 206, 207, 301,
  302, 303, 304, 305, 306, 307, 401, 402, 403, 404, 405, 406, 407,
];
